import PATHS from "./paths";
import axiosInstance from "../app/axios";

export const publicRegister = async (data: any) => {
    const result = await axiosInstance.post(`${PATHS.PUBLIC_REGISTER}`, data);
    return result.data;
};

export const getDepartments = async (code: string) => {
    const result = await axiosInstance.get(`${PATHS.PUBLIC_REGISTER}/departments?code=${code}`);
    return result.data;
};
